<template><rect width="4" height="20" rx="1" fill="#06D6A0" /></template>
